export default __webpack_public_path__ + "static/media/key-icon.fbcf9f16.svg";